import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const RectangleIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"rectangle"} ref={ref}/>
});

RectangleIcon.displayName = "RectangleIcon";
